import LandingPage from '../components/LandingPage/LandingPage'

export default LandingPage
